export const PLACEMENTS = {
  LEFT: 'left',
  RIGHT: 'right',
};
